import { FORM_MODES } from 'common/models'
import { isEqual } from 'lodash'
import { MutableRefObject, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getExciseSettingsByDateList } from 'store/settings/excise/selectors'

import { getExciseInputSetting, getFormMode } from '../helper'

export const useWaitFormReady = (formMode: FORM_MODES, formReadyRef: MutableRefObject<boolean>) => {
  const { isNewMode } = getFormMode(formMode)
  const { data: exciseSetting } = useSelector(getExciseSettingsByDateList, isEqual)
  const { isExciseSettingAvailable } = getExciseInputSetting(exciseSetting)

  useEffect(() => {
    // if isNewMode is true, set FormReady to true
    // otherwise wait for the excise setting be available to set FormReady to true
    if (!formReadyRef.current && (isNewMode || isExciseSettingAvailable)) {
      setTimeout(() => {
        formReadyRef.current = true
      }, 500)
    }
  }, [isNewMode, isExciseSettingAvailable])
}
